import axios from "axios";

let scenariosData;

async function getScenariosData() {
  const response = await axios.get(
    "//bhf-directus.wardourdigital.co.uk/say-no-to-food/items/scenarios?fields=title,strategies.*,description,sort_field,title_slug,scenario_image.filename,scenario_image.data.*.*,scenario_image_grid.filename,scenario_image_grid.data.*.*"
  );
  scenariosData = response.data.data;
}

export default async function() {
  if (!scenariosData) {
    await getScenariosData();
    return scenariosData;
  } else {
    return scenariosData;
  }
}
